module.exports = __webpack_public_path__ + "2020celebration/img/travel-r-2.aef5ce96.png";